import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AlertaCheddService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    checkEnvioChedD(idSolicitud: number, yearEnvio: number): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/importacion/envio/CheckEnvioChedD/' + idSolicitud + '/' + yearEnvio);
    }
}
